export default {"src":"/_next/static/media/makrohm.bdbb28b0.svg","height":653,"width":1700,"blurWidth":0,"blurHeight":0};